import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新攻略与资讯
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            火影同人游戏攻略、评测、资讯一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 px-2 py-1 bg-primary-500 rounded-md text-xs text-white font-medium">
                  {article.category}
                </div>
              </div>

              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>

                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-1.5">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-time-line"></i>
                    </div>
                    <span>{article.readTime}</span>
                  </div>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 border border-background-300/60 text-foreground-700 rounded-full hover:bg-primary-50 hover:text-primary-700 hover:border-primary-300 transition-all duration-300 text-sm font-medium whitespace-nowrap no-underline cursor-pointer"
          >
            查看更多文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}